import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// eslint-disable-next-line @typescript-eslint/no-var-requires
var xss = require('xss');
var options = {
  whiteList: _objectSpread(_objectSpread({}, xss.whiteList), {}, {
    nobr: true
  }),
  onIgnoreTagAttr: function onIgnoreTagAttr(tag, name, value) {
    if (name === 'style' || name === 'class') {
      // escape its value using built-in escapeAttrValue function
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      return "".concat(name, "=\"").concat(xss.escapeAttrValue(value), "\"");
    }
    if (name.substring(0, 5) === 'data-') {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      return "".concat(name, "=\"").concat(xss.escapeAttrValue(value), "\"");
    }
    if (name === 'id') {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      return "".concat(name, "=\"").concat(xss.escapeAttrValue(value), "\"");
    }
    return undefined;
  }
};
var filterXss = new xss.FilterXSS(options);
export var sanitizeDangerousChildren = function sanitizeDangerousChildren(html) {
  return filterXss.process(html);
};